import { useAuth } from "./hooks/useAuth";
import { Login } from "./pages/Login";
import { Tasks } from "./pages/Tasks";
import { Header } from "./components/Header";

export function App(): JSX.Element {
  const { status } = useAuth();

  if (status === null) {
    // Loading first auth check
    return (
      <div className="min-h-screen flex items-center justify-center text-muted text-xs uppercase tracking-nav">
        Loading…
      </div>
    );
  }

  if (!status.authenticated) {
    return <Login />;
  }

  return (
    <div className="min-h-screen">
      <Header />
      <Tasks />
    </div>
  );
}
